import { BusinessRegion, BusinessRegionResponseData } from '@city/const';
import { MemoizedSelector, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CityState, StateWithCity } from '../city-state';
import { getCityState } from './feature.selector';

export const getBusinessRegionState: MemoizedSelector<
  StateWithCity,
  StateUtils.LoaderState<BusinessRegion>
> = createSelector(getCityState, (state: CityState) => state.businessRegion);

export const getBusinessRegionValue: MemoizedSelector<StateWithCity, BusinessRegion | undefined> = createSelector(
  getBusinessRegionState,
  (state: StateUtils.LoaderState<BusinessRegion>) => StateUtils.loaderValueSelector(state),
);

export const getBusinessRegionForPointState: MemoizedSelector<
  StateWithCity,
  StateUtils.LoaderState<BusinessRegionResponseData>
> = createSelector(getCityState, (state: CityState) => state.currentPointBusinessRegion);

export const getBusinessRegionForPoint: MemoizedSelector<StateWithCity, BusinessRegionResponseData | undefined> =
  createSelector(getBusinessRegionForPointState, (state: StateUtils.LoaderState<BusinessRegionResponseData>) =>
    StateUtils.loaderValueSelector(state),
  );

export const getBusinessRegionLoading: MemoizedSelector<StateWithCity, boolean> = createSelector(
  getBusinessRegionState,
  (state: StateUtils.LoaderState<BusinessRegion>) => StateUtils.loaderLoadingSelector(state),
);

export const getBusinessRegionError: MemoizedSelector<StateWithCity, boolean> = createSelector(
  getBusinessRegionState,
  (state: StateUtils.LoaderState<BusinessRegion>) => StateUtils.loaderErrorSelector(state),
);

export const getBusinessRegionSuccess: MemoizedSelector<StateWithCity, boolean> = createSelector(
  getBusinessRegionState,
  (state: StateUtils.LoaderState<BusinessRegion>) => StateUtils.loaderSuccessSelector(state),
);
